import { useFormik, Form, FormikProvider } from 'formik';
import { Button, Input, Select } from 'styled';
import InputField from 'components/formik/InputField';
import Model from 'components/Modal';
import { createDocument, getAllData, getById, updateDocumentByID } from 'apis/customApiHandler';
import { useQuery, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import axios from 'apis/axios';
import { useCallback, useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { TD, TH } from 'styled/table';
import getFormattedDate from 'utils/helpers';
import { FaTrash, FaPlusCircle, FaSave, FaEdit, FaPlus } from "react-icons/fa";
import { IoMdAddCircle } from "react-icons/io";

const  Add = ({ data, handleClick, desable }) => {
  const queryClient = useQueryClient();
  const user = JSON.parse(localStorage.getItem("user"))
  const [file, setFile] = useState(null);
  const [hubs, setHubs] = useState([]);
  const [list, setList] = useState(data ? data?.points : [])
  const [driverDetails, setDriverDetails] = useState(
    [
    {
      name: '',
      number: '',
      id: ''
    },
    {
      name: '',
      number: '',
      id: ''
    },
    {
      name: '',
      number: '',
      id: ''
    },
    {
      name: '',
      number: '',
      id: ''
    },
    {
      name: '',
      number: '',
      id: ''
    }
  ]);
  const [driverFormData, setDriverFormData] = useState({
    name: '',
    number: '',
    id: ''
  });
  const [editIndex, setEditIndex] = useState([0,1,2,3,4]);
  const [editFlag, setEditFlag] = useState(false);

  const handleInputChange = (e, index) => {
    e.preventDefault();
    formik.setFieldValue(e.target.name, e.target.value)
  };

  // const handleFormSubmit = (e) => {
  //   e.preventDefault();
  
  //   const numberPattern = /^[0-9]{10}$/;
  
  //   if (!driverFormData.name || !driverFormData.number || driverFormData.number.length != 10 || !numberPattern.test(driverFormData.number)) {
  //     return;
  //   }
  
  //   let updatedDrivers;
  //   if (editIndex !== null) {
  //     updatedDrivers = [...driverDetails];
  //     updatedDrivers[editIndex] = driverFormData;
  //   } else {
  //     updatedDrivers = [...driverDetails, driverFormData];
  //   }
  //   console.log(updatedDrivers);
  
  //   formik.setFieldValue("driverDetails", updatedDrivers);
    
  // };




  const handleDelete = (index) => {
    const newDriverDetails = driverDetails.filter((_, i) => i !== index);
    setDriverDetails(newDriverDetails);
    formik.setFieldValue("driverDetails", newDriverDetails);
  };

  const handleEdit = (index) => {
    setEditIndex(index);
    setEditFlag(true);
    setDriverFormData(driverDetails[index]);
  };

  const [currentUser, setCurrentUser] = useState(null)
  // const { data: userRoles } = useQuery([`/roles`], () => getAllData('/roles'));
  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData('/customer-fleet', {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData('/customer-hub', {
      limit: 3000,
    })
  );
  
  const getData= async()=>{
    const data = await getAllData('/dtpDiscussionPoints', {active: true})
    formik.setValues({
      ...data,
      documents: data?.documents?? [],
      date: data?.date ?? getFormattedDate(new Date()),
      driverDetails: data?.driverDetails ?? defaultRows,
       points: data?.points?.map(item=> item._id)
      })

    setList(data?.data)
  }


  useEffect(()=>{
    console.log({data})
    if(!data){
      getData()
    }
    // console.log({data})
  }, [data])


 const sampleEntry = 
  {
    name: '',
    number: '',
    id: ''
  };
 const defaultRows = [sampleEntry, sampleEntry, sampleEntry, sampleEntry, sampleEntry]
  const formik = useFormik({
    initialValues: data ? {
      ...data,
       points: data?.points.map(item=> item._id),
       driverDetails: data?.driverDetails || defaultRows
      } : {
      date: getFormattedDate(new Date()),
      hub: null,
      fleet: null,
      trainerName: "",
      comment: "",
      documents: [],
      quarter: getCurrentFinancialQuarter(),
      points: [],
      driverDetails: defaultRows
    },
    onSubmit: async (values) => {
      try {
        console.log("driverDtails",driverDetails)
        console.log("values",values)
        values.driverDetails = values.driverDetails?.filter(item => Boolean(item.number?.length))
        if(values.driverDetails){
          values.driverDetails = values.driverDetails.sort((a, b)=> a.name.localeCompare(b.name))
        }
        console.log("Sorted details", values.driverDetails)
        const response = data ? await updateDocumentByID("manage-dtp", data._id, {...values}) : await createDocument('manage-dtp', {
          ...values,
        });
        // console.log({response})
        if (response) {
          toast.success('Successfully saved');
          queryClient.invalidateQueries('users');
          handleClick();
        }
      } catch (error) {
        return null;
      }
    },

    validate: (values) => {
      let errors = {};
      const numberPattern = /^[0-9]{10}$/;
      if (!values.hub) errors.hub = 'Required';
      if (!values.fleet) errors.fleet = 'Required';
      if (!values.trainerName) errors.trainerName = 'Required';
      if (!values.participants) errors.participants = 'Required';
      if (values.participants <= 0 ) errors.participants = 'Please enter a valid value';
      if (!values.documents?.length) errors.documents = 'Please add some Documents/Images';
      if (!values.points?.length) errors.points = 'Required';
      if (!values.date) errors.date = 'Required';
      console.log(values.driverDetails)
      errors.driverDetails = []
      values.driverDetails.map((driverFormData, index) => {
        if(!errors.driverDetails[index]){
          errors.driverDetails[index] = {}
        }
        if (driverFormData.name || driverFormData.number) {
          if (!driverFormData.name) errors.driverDetails[index].name = 'Required';
          if (!numberPattern.test(driverFormData.number)) errors.driverDetails[index].number = 'Please enter a valid number.';
          if (driverFormData.number.length != 10) errors.driverDetails[index].number = 'Please enter a 10-digit number.';
          const duplicate = values.driverDetails.find((info, dIndex)=>{
            return info.number?.length && info.number === driverFormData.number && dIndex!== index
          })
          // console.log({duplicate})
          if(duplicate?.number){
            errors.driverDetails[index].number = 'cannot be duplicate'
          }
          console.log(errors)
        }
      })
      let isEmpty = errors.driverDetails?.filter(item => Object.keys(item)?.length)?.length === 0
      if(isEmpty){
        delete errors.driverDetails
      }
      // errors.driverDetails = errors.driverDetails?.filter(item => Object.keys(item)?.length)
      // Object.keys(errors.driverDetails)?.map(key=>{
      //   console.log(errors.driverDetails)
      //   if(!Object.keys(errors.driverDetails[key])?.length){
      //     delete errors.driverDetails[key];
      //   }
      // })
      // if(!errors.driverDetails?.length){
      //   delete errors.driverDetails
      // }
      let filteredDriverInfo = values.driverDetails.filter(item => item.number?.length)
      if(!filteredDriverInfo?.length){
        errors.driverInfo = "Required"
      }
      console.log(filteredDriverInfo)

      console.log({errors})
      return errors;
    },
  });

  useEffect(() => {
    allFleets?.data?.map((fleet) => {
      if (formik.values?.fleet === fleet?._id) {
        const hubData = [];
        allHubs?.data?.map((hub) => {
          if (fleet.fleetCode === hub.fleetCode) {
            hubData.push({
              value: hub._id,
              label: hub.hubName,
            });
          }
        });
        setHubs([...hubData]);
      }
    });
  }, [formik.values , formik.values?.fleet]);

  
  function getCurrentFinancialQuarter() {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // Adding 1 because months are zero-based
  
    if (month >= 1 && month <= 3) {
      return 4;
    } else if (month >= 4 && month <= 6) {
      return 1;
    } else if (month >= 7 && month <= 9) {
      return 2;
    } else {
      return 3;
    }
  }

  // console.log({values: formik.values})


  const isDisabled = (()=>{
    let driverErrors = formik.errors.driverDetails?.reduce((total, entry) => total || Object.keys(entry)?.length, false)
   let cpy = {...formik.errors};
   console.log(driverErrors, formik.errors.driverDetails)
   delete cpy.driverDetails
    return desable || (Object.keys(cpy)?.length || driverErrors)
  })();
  function getFinancialQuarterDates(year, quarter) {
    if(!quarter){
      return {start:new Date(), end: new Date()}
    }
    // console.log({quarter})
    const currentMonth = new Date().getMonth() +1 
    const quarters = {
      4: currentMonth<=3 ? { start: new Date(year, 0, 1), end: new Date(year, 2, 31) } : { start: new Date(year+1, 0, 1), end: new Date(year+1, 2, 31) },
      1: currentMonth<6 ? { start: new Date(year, 3, 1), end: new Date(year, 5, 30) } : { start: new Date(year+1, 3, 1), end: new Date(year+1, 5, 30) },
      2: currentMonth<9 ? { start: new Date(year, 6, 1), end: new Date(year, 8, 30) } : { start: new Date(year+1, 6, 1), end: new Date(year+1, 8, 30) },
      3: currentMonth<12 ? { start: new Date(year, 9, 1), end: new Date(year, 11, 31) } : { start: new Date(year+1, 9, 1), end: new Date(year+1, 11, 31) }
    };
  
    return quarters[quarter];
  }
  
  // console.log(driverDetails)

  // console.log({"vals": formik.values})


  return (
    <Model
      handleClick={handleClick}
      title={"Add DTP Plan"}
      className="max-w-3xl"
    >
      <div>
        <FormikProvider value={formik}>
          <Form className="px-5 text-gray-700 text-base grid grid-cols-1 md:grid-cols-2 gap-5 w-full">
            <label className="py-3">
              Select Fleet <span className="text-red-400">*</span>
              <ReactSelect
                options={allFleets?.data?.map((fleet) => ({
                  value: fleet._id,
                  label: fleet.fleetName,
                }))}
                value={{
                  value: formik.values?.fleet,
                  label: allFleets?.data?.find(
                    (d) => d?._id === formik.values?.fleet
                  )?.fleetName,
                }}
                onChange={(value) => {
                  formik.setFieldValue("fleet", value.value);
                  formik.setFieldValue("hub", "");
                }}
                name="fleet"
                isMulti={false}
              />
              {formik.touched.fleet && formik.errors.fleet && (
                <p className="text-red-500 font-normal">
                  *{formik.errors.fleet}
                </p>
              )}
            </label>

            <label className="py-3">
              Select Hub<span className="text-red-400">*</span>
              <ReactSelect
                options={hubs}
                value={{
                  value: formik.values?.hub,
                  label: allHubs?.data?.find(
                    (d) => d?._id === formik.values?.hub
                  )?.hubName,
                }}
                onChange={(value) => {
                  formik.setFieldValue("hub", value.value);
                }}
                name="hub"
                isMulti={false}
              />
              {formik.touched.hub && formik.errors.hub && (
                <p className="text-red-500 font-normal">
                  *{formik.errors?.hub}
                </p>
              )}
            </label>

            <InputField
              type="number"
              label="No Of Participants"
              name="participants"
              required={true}
            />
            <InputField
              type="text"
              label="Trainer Name"
              name="trainerName"
              required={true}
            />

            <div className="overflow-hidden border-b border-gray-200 sm:rounded-lg md:col-span-2">
              <h1 className="text-gray-600 py-2">Driver Details <span className="text-red-500 required-dot">* {formik.errors?.driverInfo}</span></h1>
              
              <table className="w-full divide-y">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col">S.N.</TH>
                    <TH scope="col">Name</TH>
                    <TH scope="col">Number</TH>
                    <TH scope="col">ID</TH>
                    <TH scope="col">Action</TH>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {formik.values.driverDetails &&
                    formik.values.driverDetails.map((driver, index) => (
                      <tr key={index}>
                        <TD>{index + 1}</TD>
                        <TD className="">
                          {true ? (
                            <InputField
                              type="text"
                              name={`driverDetails[${index}].name`}
                              index={index}
                              key={index + 'name'}
                              value={formik.values.driverDetails[index]?.name}
                              onChange={(e) => handleInputChange(e, index)}
                              required={true}
                            />
                          ) : (
                            driver.name
                          )}
                        </TD>
                        <TD className="">
                          {true ? (
                            <InputField
                              type="text"
                              name={`driverDetails[${index}].number`}
                              index={index}
                              key={index + 'number'}
                              value={formik.values.driverDetails[index]?.number}
                              onChange={(e) => handleInputChange(e, index)}
                              required={true}
                            />
                          ) : (
                            driver.number
                          )}
                        </TD>
                        <TD className="">
                          {true ? (
                            <InputField
                              type="text"
                              name={`driverDetails[${index}].id`}
                              index={index}
                              value={formik.values.driverDetails[index]?.id}
                              key={index + 'id'}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          ) : (
                            driver.id
                          )}
                        </TD>
                        <TD className="flex">
                          {false ? (
                            <></>
                          ) : (
                            <>
                              {/* <div
                                onClick={()=>{handleFormSubmit(formik.values.driverDetails[index], index)}}
                                className="p-2 m-2 rounded-md bg-blue-500 hover:bg-blue-600 text-white flex items-center justify-center"
                              >
                                <FaSave />
                              </div> */}

                              <button
                                type='button'
                                onClick={(e) => {
                                  e.preventDefault();
                                  console.log(formik.values.driverDetails)
                                  formik.setFieldValue("driverDetails", [
                                    ...formik.values.driverDetails?.filter((item, dIndex) => index !== dIndex),
                                  ])
                                  setEditIndex([...editIndex.filter(item => item !== index)])
                                }}
                                className="p-2 m-2 rounded-md bg-red-500 hover:bg-red-600 text-white flex items-center justify-center"
                              >
                                <FaTrash />
                              </button>
                            </>
                          )}
                        </TD>
                      </tr>
                    ))}
                </tbody>
              </table>
              <button
              type="button"
                onClick={() =>{
                  formik.setFieldValue("driverDetails", [
                    ...formik.values.driverDetails,
                    { name: "", phone: "", id: "" },
                  ])
                }
                }
                className="p-2 m-2 rounded-md bg-yellow-500 hover:bg-orange-300 text-white flex items-right justify-right float-right"
              >
                <IoMdAddCircle/>
              </button>
            </div>

            <label className="col-span-2 flex flex-col w-[3/4]">
              <span className="mb-1">
                Discussion Points Covered{" "}
                <span className="text-red-400">*</span>{" "}
              </span>
              {formik.touched.points && formik.errors.points && (
                <span className="text-red-500 font-normal">
                  *--{formik.errors.points}
                </span>
              )}
              <label className="">
                {list?.length &&
                  list?.map((item) => {
                    return (
                      <div className="flex flex-row gap-x-2">
                        {" "}
                        <InputField
                          className="py-1"
                          type="checkbox"
                          name={item.description}
                          checked={formik.values?.points?.includes(
                            item?._id?.toString()
                          )}
                          onChange={(e) => {
                            const current = formik.values.points?.length
                              ? formik.values.points
                              : [];
                            if (e.target.checked) {
                              formik.setFieldValue("points", [
                                ...current,
                                item._id,
                              ]);
                            } else
                              formik.setFieldValue("points", [
                                ...current.filter(
                                  (point) => point !== item._id
                                ),
                              ]);
                          }}
                        />{" "}
                        <span className="py-1"> {item.description} </span>{" "}
                      </div>
                    );
                  })}
              </label>
            </label>

            <div className="col-span-2">
              <InputField
                type="textarea"
                label="Additional Points"
                name="comment"
              />
            </div>
            <InputField
              type="file"
              label="Images"
              name="documents"
              formik={formik}
              required={true}
              limit={6}
              compressImage={true}
              maxSize={1 * 1024 * 1024}
              accept="image/png, image/jpeg, image/jpg"
              fileType = "(Png, Jpg, Jpeg)"
            />
            <span className="text-red-400">*</span>
            {formik.errors.documents && (
              <span className="text-red-500 font-normal">
                *{formik.errors.documents}
              </span>
            )}
          </Form>
          <div className="px-5 flex justify-end items-center gap-4 py-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button
              type="button"
              bgPrimary
              onClick={formik.handleSubmit}
              disabled={isDisabled}
              // disabled={desable || Object.keys(formik.errors)?.length}
            >
              Save Changes
            </Button>
          </div>
        </FormikProvider>
      </div>
    </Model>
  );
};

export default Add;
